import React from "react";
import styles from "./authLayout.module.css";
import logoText from "../../assets/logo-text.svg";
import { Outlet, useLocation } from "react-router-dom";
import { CSSTransition, TransitionGroup } from "react-transition-group";

const AuthLayout = () => {
  const location = useLocation();

  return (
    <div className={styles["login-page"]}>
      <div className={styles["login-left"]}>
        <div className={styles["login-info"]}>
          <img
            src={logoText}
            alt="Academetrics Logo"
            className={styles["login-logo-left"]}
          />

          <h1>
            Conhecimento <br />e Oportunidades
          </h1>
          <p>
            Obtenha análises gerenciais sobre dados de sua <br></br> Instituição de Ensino para tomar as melhores decisões
          </p>
        </div>
      </div>

      <TransitionGroup className={styles.pageContent}>
        <CSSTransition key={location.pathname} classNames="fade" timeout={300}>
          <Outlet />
        </CSSTransition>
      </TransitionGroup>
    </div>
  );
};

export default AuthLayout;
